export function mapLocationToLeadFields(selectedLocation: any) {
    if (!selectedLocation) return { locationData: {} };

    const type = selectedLocation?.type; // "city" | "area" from LM API

    const isCity = type === 'city';
    const isArea = type === 'area';

    return {
        locationData: {
            type,
            pincode: selectedLocation?.pincode || selectedLocation?.location_pincode || selectedLocation?.tehsil_pincode || undefined,
            cityId: selectedLocation?.cityId || undefined,
            stateCode: selectedLocation?.stateCode || selectedLocation?.state?.state_id || selectedLocation?.state_id || undefined,
            stateName: selectedLocation?.stateName || selectedLocation?.state?.state_name || selectedLocation?.state_name || undefined,
            stateSlug: selectedLocation?.stateSlug || undefined,
            districtCode: selectedLocation?.districtCode || selectedLocation?.district?.district_id || selectedLocation?.district_id || undefined,
            districtName: selectedLocation?.districtName || selectedLocation?.district?.district_name || selectedLocation?.district_name || undefined,
            districtSlug: selectedLocation?.districtSlug || undefined,
            cityName: isCity ? (selectedLocation?.name || undefined) : undefined,
            citySlug: isCity ? (selectedLocation?.slug || undefined) : undefined,
            areaName: isArea ? (selectedLocation?.name || undefined) : undefined,
            areaSlug: isArea ? (selectedLocation?.slug || undefined) : undefined,
            // Used to find dealers near the user's location
            latitude: typeof selectedLocation?.latitude === 'number' ? selectedLocation.latitude : undefined,
            longitude: typeof selectedLocation?.longitude === 'number' ? selectedLocation.longitude : undefined,
        },
    };
}

export function buildLeadPayload(lead: any, extras: { carId?: string | null; variantId?: string | null, dealerId?: string | null, leadSource?: string | null } = {}) {
    const { carId, variantId, dealerId, leadSource } = extras;
    const currentUrl = lead?.current_url || (typeof window !== 'undefined' ? window.location.href : undefined);

    const ld = lead.locationData || {};

    const locationData = {
        type: ld.type || undefined,
        pincode: ld.pincode || undefined,
        cityId: ld.cityId || undefined,
        stateCode: ld.stateCode || undefined,
        stateName: ld.stateName || undefined,
        stateSlug: ld.stateSlug || undefined,
        districtCode: ld.districtCode || undefined,
        districtName: ld.districtName || undefined,
        districtSlug: ld.districtSlug || undefined,
        cityName: ld.cityName || undefined,
        citySlug: ld.citySlug || undefined,
        areaName: ld.areaName || undefined,
        areaSlug: ld.areaSlug || undefined,
        latitude: typeof ld.latitude === 'number' ? ld.latitude : undefined,
        longitude: typeof ld.longitude === 'number' ? ld.longitude : undefined,
    };

    const payload: any = {
        name: lead.name?.trim() || "",
        phone: lead.phone?.trim() || "",
        location: lead.location || ld.location || "",
        locationData,
    };

    if (lead.email?.trim()) payload.email = lead.email.trim();
    if (currentUrl) payload.current_url = currentUrl;   

    if (carId) payload.car_id = carId;
    if (variantId) payload.variant_id = variantId;
    if (dealerId) payload.dealer = dealerId;
    if (leadSource) payload.lead_source = leadSource;

    const utmKeys = ['utm_campaign', 'utm_medium', 'utm_term', 'utm_source', 'utm_content'] as const;
    for (const key of utmKeys) {
        if (lead[key]) payload[key] = lead[key];
    }

    return payload;
}
